import { ref, watch } from 'vue'
import { toast } from 'vue-sonner'
import { invoke } from '~/lib/tauriInvoke'
import { liveKitManager } from '~/lib/livekit/manager'

// «Громкая связь» in the phone's call controls (CallControls.vue): the call's audio through the
// loudspeaker instead of the earpiece. The route itself is native (src-tauri/src/commands/audio_route.rs);
// this only remembers what was asked for. Module-level, so every copy of the controls shows the
// same state, and leaving the voice channel puts the default route back for the next call.

const enabled = ref(false)

async function setEnabled(value: boolean) {
  try {
    await invoke('set_speakerphone', { enabled: value })
    enabled.value = value
  } catch (error) {
    console.warn('[Speakerphone] switch failed', error)
    toast.error('Не удалось переключить громкую связь')
  }
}

watch(() => liveKitManager.state.activeVoiceChannelId, (channelId) => {
  if (!channelId && enabled.value) void setEnabled(false)
})

export function useSpeakerphone() {
  return {
    enabled,
    toggle: () => setEnabled(!enabled.value),
  }
}
